import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/Login.vue'
import Cookies from 'js-cookie'
import store from '../store'

import { clearAllAuthData } from '../components/auth-utils';

// Import Vue Loading Overlay styles but we'll use a simpler approach
import 'vue-loading-overlay/dist/css/index.css'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      public: true
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/ForgotPassword.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/masters',
    name: 'masters',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "masters" */ '../views/MasterView.vue')
  },
  {
    path: '/authorization_models',
    name: 'auth_models',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "auth_models" */ '../views/AuthorizationModel.vue')
  },
  {
    path: '/products',
    name: 'products',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "products" */ '../views/Products.vue')
  },
  {
    path: '/branches',
    name: 'branches',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "branches" */ '../views/Branches.vue')
  },
  {
    path: '/customers',
    name: 'customers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customers" */ '../views/Customers.vue')
  },
  {
    path: '/targets',
    name: 'targets',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "targets" */ '../views/Targets.vue')
  },
  {
    path: '/users',
    name: 'users',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "customers" */ '../views/Users.vue')
  },
  {
    path: '/assignment-config',
    name: 'assignment-config',
    component: () => import('../views/AssignmentConfig.vue')
  },
  {
    path: '/leads',
    name: 'leads',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "leads" */ '../views/Leads.vue')
  },
  {
    path: '/lead-analytics',
    name: 'lead-analytics',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "lead-analytics" */ '../views/LeadAnalytics.vue')
  },
  {
    path: '/leads/intelligence',
    name: 'lead-intelligence',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "lead-intelligence" */ '../views/LeadIntelligence.vue')
  },
  {
    path: '/business_rules',
    name: 'business_rules',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "business_rules" */ '../views/BusinessRules.vue')
  },
  {
    path: '/intelligence-config',
    name: 'intelligence_config',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "intelligence_config" */ '../views/IntelligenceConfig.vue')
  },
  {
    path: '/location-tracking',
    name: 'location-tracking',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "location_tracking" */ '../views/LocationTracking.vue')
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPassword.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/employees',
    name: 'employees',
    component: () => import('../views/Employees.vue')
  },
  {
    path: '/vendors',
    name: 'vendors',
    component: () => import('../views/Vendors.vue')
  },
  {
    path: '/contract-staff',
    name: 'contract-staff',
    component: () => import('../views/ContractStaff.vue')
  },
  {
    path: '/hierarchy',
    name: 'hierarchy',
    component: () => import('../views/HierarchyView.vue')
  },
  {
    path: '/hierarchy-management',
    name: 'hierarchy-management',
    component: () => import('../views/HierarchyManagement.vue')
  },
  {
    path: '/delegation-matrix-manager',
    name: 'delegation-matrix-manager',
    component: () => import('../components/delegation/DelegationMatrixManager.vue')
  },
  {
    path: '/business-dashboard',
    name: 'business-dashboard',
    component: () => import('../views/BusinessDashboard.vue')
  },
  {
    path: '/budget-targets',
    name: 'budget-targets',
    component: () => import('../views/BudgetTargetsManagement.vue')
  },
  {
    path: '/vendor-attendance-reports',
    name: 'vendor-attendance-reports',
    component: () => import('../views/VendorAttendanceReports.vue')
  },
  {
    path: '/role-management',
    name: 'role-management',
    component: () => import('../views/RoleManagement.vue')
  },
  // Geography Management Routes
  {
    path: '/states',
    name: 'states',
    component: () => import('../views/States.vue')
  },
  {
    path: '/districts',
    name: 'districts',
    component: () => import('../views/Districts.vue')
  },
  {
    path: '/cities',
    name: 'cities',
    component: () => import('../views/Cities.vue')
  },
  {
    path: '/pincodes',
    name: 'pincodes',
    component: () => import('../views/Pincodes.vue')
  },
  // Leave Management Routes
  {
    path: '/leave-management',
    name: 'leave-management',
    component: () => import('../views/LeaveManagement.vue')
  },
  {
    path: '/leave-rules',
    name: 'leave-rules',
    component: () => import('../views/LeaveRules.vue')
  },
  {
    path: '/approval-flows',
    name: 'approval-flows', 
    component: () => import('../views/ApprovalFlows.vue')
  },
  {
    path: '/leave-analytics',
    name: 'leave-analytics',
    component: () => import('../views/LeaveAnalytics.vue')
  },
  {
    path: '/employee-lifecycle',
    name: 'employee-lifecycle',
    component: () => import('../views/EmployeeLifecycle.vue')
  },
  {
    path: '/system-initialization',
    name: 'system-initialization',
    component: () => import(/* webpackChunkName: "system-initialization" */ '../views/SystemInitialization.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN', 'HR']
    }
  },
  // Verification Management Routes
  {
    path: '/verification-templates',
    name: 'verification-templates',
    component: () => import('../views/VerificationTemplates.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN', 'MANAGER']
    }
  },
  {
    path: '/verification-dashboard',
    name: 'verification-dashboard',
    component: () => import('../views/VerificationDashboard.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN', 'MANAGER', 'SUPERVISOR']
    }
  },
  {
    path: '/verification/:id',
    name: 'verification-details',
    component: () => import('../views/VerificationDetails.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN', 'MANAGER', 'SUPERVISOR', 'AGENT']
    }
  },
  {
    path: '/verification-file-demo',
    name: 'verification-file-demo',
    component: () => import('../views/VerificationFileDemo.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN', 'MANAGER']
    }
  },
  // Offline Configuration Routes
  {
    path: '/offline/settings',
    name: 'offline-settings',
    component: () => import('../views/OfflineSettings.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN']
    }
  },
  {
    path: '/offline/monitoring',
    name: 'offline-monitoring',
    component: () => import('../views/OfflineMonitoring.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN']
    }
  },
  {
    path: '/offline/audit',
    name: 'offline-audit',
    component: () => import('../views/OfflineAudit.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN']
    }
  },
  {
    path: '/product-catalog',
    name: 'product-catalog',
    component: () => import('../views/ProductCatalog.vue'),
    meta: {
      requiresAuth: true,
      requiredRoles: ['ADMIN']
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Create a simple loading state variable
let isLoading = false;

// Use a simple DOM-based loading indicator instead of the library
const showLoadingIndicator = () => {
  try {
    isLoading = true;
    // Check if loading element already exists
    let loader = document.getElementById('vue-route-loader');

    if (!loader) {
      // Create a simple loading indicator
      loader = document.createElement('div');
      loader.id = 'vue-route-loader';
      loader.style.position = 'fixed';
      loader.style.top = '0';
      loader.style.left = '0';
      loader.style.width = '100%';
      loader.style.height = '2px';
      loader.style.backgroundColor = '#D0A441';
      loader.style.zIndex = '9999';
      loader.style.transition = 'width 0.3s';
      document.body.appendChild(loader);
    }

    // Start animation
    setTimeout(() => {
      if (loader && isLoading) {
        loader.style.width = '90%';
      }
    }, 10);
  } catch (e) {
    console.error('Error showing loader:', e);
  }
};

const hideLoadingIndicator = () => {
  try {
    isLoading = false;
    const loader = document.getElementById('vue-route-loader');

    if (loader) {
      // Complete animation then remove
      loader.style.width = '100%';
      setTimeout(() => {
        if (loader && loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }
      }, 200);
    }
  } catch (e) {
    console.error('Error hiding loader:', e);
  }
};

router.beforeEach(async (to, from) => {
  // Show loading indicator
  showLoadingIndicator();

  // Force clearing all auth data if force=true param is present
  if (to.query.force === 'true' && to.name === 'login') {
    // Import here to avoid circular deps
    const { clearAllAuthData } = await import('../components/auth-utils');
    clearAllAuthData(false); // Don't redirect since we're already going to login

    // Remove the force query parameter to prevent loops
    return {
      name: 'login',
      query: { ...to.query, force: undefined }
    };
  }

  // If we have a token but no user, fetch current user profile
  if (store.getters.isSignedIn && !store.getters.currentUser) {
    try {
      const { data: me } = await store.state.simforce.get('/me');
      store.commit('setUser', me);
    } catch (e) {
      // Token invalid or expired, clear all auth and redirect to login
      clearAllAuthData();
      return {
        name: 'login',
        query: { redirect: to.fullPath, t: Date.now().toString() }
      };
    }
  }

  // Handle redirect after login
  if (to.path === '/' && from.path.includes('/login') && to.query.redirect) {
    // User just logged in and we have a redirect target
    const redirectTarget = to.query.redirect.toString();
    console.log('Redirecting after login to:', redirectTarget);
    return { path: redirectTarget };
  }

  // If user is coming from login page with successful login
  if (from.path.includes('/login') && !to.path.includes('/login')) {
    // Set a flag that we're in post-login navigation
    try {
      sessionStorage.setItem('post_login_navigation', 'true');

      // Create a timeout to clear this flag
      setTimeout(() => {
        sessionStorage.removeItem('post_login_navigation');
      }, 5000); // Clear after 5 seconds
    } catch (e) {
      console.warn('Error setting post-login state:', e);
    }
  }

  // Check if the route requires authentication
  if (!to.meta.public) {
    const isAuth = store.getters.isSignedIn;
    if (!isAuth) {
      return {
        name: 'login',
        query: {
          redirect: to.fullPath !== '/' ? to.fullPath : undefined,
          t: Date.now().toString()
        }
      };
    }
  }

  return true; // Explicitly return true to indicate navigation should proceed
})

router.afterEach(() => {
  // Hide the loader
  hideLoadingIndicator();
})

export default router
